import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";

export const isLoanDomain = (
	domain: ClientPortfolioDomainEnum | undefined,
): boolean =>
	domain === ClientPortfolioDomainEnum.Loans ||
	domain === ClientPortfolioDomainEnum.Leasing ||
	domain === ClientPortfolioDomainEnum.BusinessLoans;
